module.exports = __webpack_public_path__ + "img/tjjj.4830664a.jpg";